<template>
  <div class="container-fluid">

    <div class="row py-3">
      <div class="col-md-12">
        <h1 class="text-center">Client details</h1>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <client-table :client="client" :groups="groups" v-if="client"></client-table>
      </div>

      <div class="col-md-12" v-if="hasPortfolio">
        <div class="card portfolio-card">
          <div class="card-header">
            <h2>Portfolio #{{ client.portfolios[0] }}: {{ portfolioStats ? portfolioStats.totalValueBGN : null }} BGN / {{ totalValueEUR }} EUR</h2>
          </div>
          <div class="card-body">
            <b-tabs v-model="tabIndex">

              <!-- TAB #1 -->
              <b-tab title="Overview" active class="pt-5">
                <div v-if="portfolioAssets && portfolioAssets.length" class="mb-5 clearfix">
                  <pie-chart :assets="portfolioAssets"></pie-chart>
                  <assets-table :coins="portfolioAssets"></assets-table>
                  <p>* The prices are taken from <a href="https://coingecko.com/">https://coingecko.com/</a> on {{ updateTime }} UTC.</p>
                    <b-btn size="sm" class="float-left" variant="secondary" @click="onCopy(this)">copy table</b-btn>
                    <span v-show="copyVisible" class="text-muted ml-2">copied!</span>
                </div>

                <h3>Return on Investment (BGN)</h3>
                <totals-table v-if="portfolioStats" :data="portfolioStats"></totals-table>
                <div v-if="!portfolioStats" class="alert text-center">No Data</div>
              </b-tab>

              <!-- TAB #2 -->
              <b-tab title="Transactions" class="pt-5">
                <transactions-table v-if="tabIndex === 1" :portfolioId="client.portfolios[0]"></transactions-table>
              </b-tab>

              <!-- TAB #3 -->
              <b-tab title="Tax Info" class="pt-5">
                <taxinfo-table v-if="tabIndex === 2" :portfolioId="client.portfolios[0]"></taxinfo-table>
              </b-tab>

            </b-tabs>
          </div>
        </div>
      </div>

      <div class="col-md-12 mt-5">
        <button type="button" class="btn btn-warning" @click="resetPass()">Reset Password</button>
        <!-- <button type="button" class="btn btn-danger" @click="deactivate()">Deactivate</button> -->
      </div>

      <loading :loading="loading"></loading>

    </div>

  </div>
</template>


<script>
import userService from '../services/userService'

import AssetsTable from '../components/tables/AssetsTable'
import ClientTable from '../components/tables/ClientTable'
import TotalsTable from '../components/tables/PortfolioTotalsTable'
import TransactionsTable from '../components/tables/TransactionsTable'
import TaxinfoTable from '../components/tables/TaxinfoTable'
import PieChart from '../components/charts/AssetsPieChart'

export default {
  components: {
    ClientTable,
    TotalsTable,
    TransactionsTable,
    TaxinfoTable,
    AssetsTable,
    PieChart,
  },
  created() {
    this.loading = true
    const clients = this.$store.getters.getClients()
    let client
    let clientPromise
    let groupPromise
    groupPromise = this.$store.dispatch('loadGroups')

    if (clients && clients.length) {
      client = clients.find(cl => cl.id === this.clientId)
    }

    if (!client) {
      client = this.$store.getters.getClient
    }

    if (!client || client.id !== this.clientId) {
      // We have to fetch the client
      clientPromise = this.$store.dispatch('getClient', this.clientId)
    } else {
      // We alrady have the client
      clientPromise = this.$store.dispatch('setClient', client)
    }

    clientPromise
      .then(client => client.portfolios)
      .then(portfolioIds => {
        if (!portfolioIds || !portfolioIds.length) {
          return Promise.reject(new Error('The client does not have any portfolio.'))
        }
        return this.$store.dispatch('loadPortfolioDetails', portfolioIds[0])
      })
      .then(() => {
        this.hasPortfolio = true
      })
      .finally(() => {
        this.loading = false
      })
      .catch(() => {
        this.hasPortfolio = false
      })

    Promise.all([clientPromise, groupPromise])
      .finally(() => {
      })
  },
  props: ['id'],
  data() {
    return {
      loading: false,
      tabIndex: null,
      hasPortfolio: null,
      copyVisible: false,
    }
  },
  methods: {
    resetPass() {
      if (window.confirm(`Are you sure you want to reset the password of ${this.client.name} with Client ID: ${this.client.clientId}? If 'YES', the user will receive an email with a link to set a new password.`)) {
        userService.sendMailForNewPass(this.client.email)
      }
    },
    deactivate() {
      if (window.confirm(`Are you sure you want to deactivate user ${this.client.name} with Client ID: ${this.client.id}?`)) {
        userService.deactivate(this.client.email)
      }
    },
    onCopy() {
      let assettable = document.getElementById('assets_table_fund')
      let toformat = assettable.querySelectorAll('.formatnum')
      toformat.forEach(
        (element) => {
          element.setAttribute('style', 'mso-number-format: \'0\\.00000000\'')
        }
      )
      let el = document.createElement('textarea')
      document.body.appendChild(el)
      el.value = assettable.outerHTML.replace(new RegExp('&nbsp;', 'g'), '').replace(/,/g, '.')
      // el.setAttribute('readonly', '')
      el.select()
      document.execCommand('copy')
      document.body.removeChild(el)
      this.copyVisible = true
      setTimeout(() => { this.copyVisible = false }, 1000)
    },
  },
  computed: {
    clientId() {
      return +this.id
    },
    client() {
      return this.$store.getters.getClient
    },
    portfolioStats() {
      return this.$store.getters.getSPStats
    },
    portfolioAssets() {
      return this.$store.getters.getSPAssets
    },
    updateTime() {
      return this.$store.getters.getUpdateTime
    },
    groups() {
      return this.$store.getters.getGroups
    },
    totalValueEUR() {
      if (!this.portfolioStats || !this.portfolioStats.totalValueBGN) {
        return null
      }
      // Parse the BGN value (handles European format: "1 254 870,22")
      const bgnString = String(this.portfolioStats.totalValueBGN)
      const bgnNumber = parseFloat(bgnString.replace(/\s/g, '').replace(',', '.'))
      // Convert BGN to EUR (fixed rate: 1 EUR = 1.95583 BGN)
      const eurNumber = bgnNumber / 1.95583
      // Format back to European number format
      return eurNumber.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ' ').replace('.', ',')
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/-service-app/pages/ClientPage.vue